import { graphql, useStaticQuery } from 'gatsby';
import constants from '../utils/utils';

export default () => {
  const { allContentfulIslandPetroleum } = useStaticQuery(
    graphql`
      query MyQuery {
        allContentfulIslandPetroleum(
          filter: {
            identifier: { type: { eq: "header" }, node_locale: { eq: "en-US" } }
          }
        ) {
          edges {
            node {
              title
              name
              slug
              identifier {
                type
              }
              sections {
                ... on ContentfulListOfImageWithPath {
                  id
                  title
                  type
                  listOfImagesWithPath {
                    title
                    type
                    path
                    richText {
                      raw
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  );
  return allContentfulIslandPetroleum.edges[0].node.sections.filter(
    (item) => item.type === 'imageWithPath'
  )[0];
};
